import { t } from '../../../common/i18n/services/i18n-translation-with-default'

const TheoryLessons = () => <h1> {t('lessons.theory.title')} </h1>

export default TheoryLessons
